module.exports = __webpack_public_path__ + "img/career.c23c9ba1.svg";